const systemRouter = [
  {
    path: "/system",
    component: () => import("@/layout/LayoutIndex.vue"),
    meta: { title: "绯荤粺绠＄悊", icon: "system", requireAuth: true },
    name: "system",
    redirect: "/home",
    children: [
      {
        path: "/system/user",
        component: () => import("@/views/systembase/user/UserIndex.vue"),
        name: "user",
        meta: { title: "鐢ㄦ埛绠＄悊", requireAuth: true },
      },
      {
        path: "/system/role",
        component: () => import("@/views/systembase/role/RoleIndex.vue"),
        name: "role",
        meta: { title: "瑙掕壊绠＄悊", requireAuth: true },
      },
      {
        path: "/system/menu",
        component: () => import("@/views/systembase/menu/MenuIndex.vue"),
        name: "menu",
        meta: { title: "鑿滃崟绠＄悊", requireAuth: true },
      },
      {
        path: "/system/dept",
        component: () => import("@/views/systembase/dept/DeptIndex.vue"),
        name: "dept",
        meta: { title: "閮ㄩ棬绠＄悊", requireAuth: true },
      },
      {
        path: "/system/modules",
        component: () => import("@/views/systembase/modules/ModuleIndex.vue"),
        name: "modules",
        meta: { title: "妯″潡绠＄悊", requireAuth: true },
      },
      {
        path: "/system/dictType",
        component: () =>
          import("@/views/systembase/dictType/DictTypeIndex.vue"),
        name: "dictType",
        meta: { title: "瀛楀吀绠＄悊", requireAuth: true },
      },
      {
        path: "/system/position",
        component: () =>
          import("@/views/systembase/position/PositionIndex.vue"),
        name: "position",
        meta: { title: "宀椾綅绠＄悊", requireAuth: true },
      },
      {
        path: "/system/deviceconfig",
        component: () =>
          import("@/views/systembase/deviceconfig/DeviceConfigIndex.vue"),
        name: "deviceconfig",
        meta: { title: "璁惧閰嶇疆", requireAuth: true },
      },
      {
        path: "/system/unitManage",
        component: () => import("@/views/systembase/unit/UnitManageIndex.vue"),
        name: "unitManage",
        meta: { title: "鍗曚綅绠＄悊", requireAuth: true },
      },
      {
        path: "/system/customerServiceDesk",
        component: () => import("@/views/systembase/customerService/ManualServiceDesk.vue"),
        name: "customerServiceDesk",
        meta: { title: "人工客服工作台", requireAuth: true, hideCustomerServiceLauncher: true },
      },
    ],
  },
];

export default systemRouter;
